import React, { useState, useCallback, useEffect } from "react";
// import { useStaticQuery, graphql } from "gatsby";
import { connectMenu, connectCurrentRefinements } from "react-instantsearch-dom";
import classNames from "classnames";
import { Trans } from "@lingui/macro";
import { withI18n } from "@lingui/react";
import categoriesTranslations from "~/hooks/categoriesTranslations";
import list from "~/locales/es/filters.json";

const MenuList = ({ items, refine, limited, style, i18n, setMenuIsVisible, ...rest }) => {
  // const data = useStaticQuery(graphql`
  //   query {
  //     allVtutorStructuredContent {
  //       distinct(field: permalink___category)
  //     }
  //   }
  // `);

  // const categories = data.allVtutorStructuredContent.distinct;
  const categories = Object.keys(list);

  const [isShowMore, setShowMore] = useState(false);
  const [loading, setLoadingState] = useState(false);
  const [menuItems, setMenuItems] = useState([]);

  let showMoreClasses = limited
    ? classNames("relative", {
        course_categories: !isShowMore,
      })
    : undefined;

  const show_more_handle = useCallback(
    (e) => {
      e.preventDefault();

      setShowMore(!isShowMore);
    },
    [isShowMore]
  );

  useEffect(() => {
    if (items.length > 0 && menuItems.length === 0) setMenuItems(items);
    return () => {
      return false;
    };
  }, [items, menuItems]);

  return (
    <>
      <ul className={showMoreClasses} style={style} id="filterMenu">
        <li className="flex w-full leading-tight">
          <ClearRefinements setMenuIsVisible={setMenuIsVisible} clearsQuery={true} />
        </li>
        {/* {categories.length > 0 && menuItems.length > 0 ? ( */}
        <>
          {categories.map((category, index) => {
            const item = catIsRefined(items, category);

            const classes = classNames("capitalize block text-sm flex items-center w-full mt-2 leading-tight", {
              "text-brand-primary": item.isRefined,
              "font-semibold": item.isRefined,
            });

            const classesIcon = classNames("mr-2", {
              "text-brand-primary": item.isRefined,
              "fill-current": item.isRefined,
            });

            return (
              <li key={`cat_${index}`} className="whitespace-nowrap pb-2 mb-2">
                <button
                  className={classes}
                  onClick={(event) => {
                    event.preventDefault();
                    refine(category);
                    if (typeof setMenuIsVisible !== "undefined") setMenuIsVisible(false);
                    setLoadingState(true);
                  }}
                  disabled={loading}
                >
                  <span className={`icon-cat-${category} ${classesIcon}`} />
                  <span className="text-left flex-1 xl:text-base">
                    {categoriesTranslations(category)}
                    {/* <span className="pl-1">({item.count})</span> */}
                  </span>
                </button>
              </li>
            );
          })}
        </>
        {/* // ) : (
        //   <div className="mock">
        //     {Array(20)
        //       .fill(1)
        //       .map((el, i) => {
        //         return (
        //           <li className="mb-1" key={i}>
        //             <button disabled={true} className="flex">
        //               <div className="bg-gray-300 w-8 h-6 mr-2" />
        //               <span className="bg-gray-300 w-32 h-6 pb-2 mb-1 text-left flex-1 xl:text-base xl:mb-2" />
        //             </button>
        //           </li>
        //         );
        //       })}
        //   </div>
        // )} */}
      </ul>
      {limited && (
        <div className="text-center">
          <button className="show_more font-bold py-2" onClick={show_more_handle}>
            {!isShowMore ? (
              <>
                <Trans>Show more</Trans>
                <i className="fas fa-chevron-down align-middle text-xs font-bold ml-1" />
              </>
            ) : (
              <>
                <Trans>Show less</Trans>
                <i className="fas fa-chevron-up align-middle text-xs font-bold ml-1" />
              </>
            )}
          </button>
        </div>
      )}
    </>
  );
};

function catIsRefined(items, cat_name) {
  const find = items.find((item) => item.label === cat_name);

  return {
    isRefined: find ? find.isRefined : false,
    count: find ? find.count : 0,
  };
}

const ClearRefinements = connectCurrentRefinements(({ items, refine, setMenuIsVisible }) => (
  <button
    className="capitalize text-sm flex w-full"
    onClick={() => {
      refine(items);
      if (typeof setMenuIsVisible !== "undefined") setMenuIsVisible(false);
    }}
    disabled={!items.length}
  >
    <span className={`icon-cat-all text-brand-link-gray mr-2 text-lg`} />
    <span className="text-left flex-1 xl:text-base">
      <Trans>All Courses</Trans>
    </span>
  </button>
));

const CustomMenuList = connectMenu(MenuList);

export default withI18n()(CustomMenuList);
